import { historyProgress } from './agencyDigest';
import { buildSampleDigest } from './agencySampleDigest';
import type { IAgencyInsights } from './useAgencyInsights';

/** What the tab shows under the admin-only demo setting: the invented caseload, and nobody real. */
export const buildDemoInsights = (params: { now: Date; retry: () => Promise<void> }): IAgencyInsights => {
    const digest = buildSampleDigest(params.now);
    return {
        hasLoaded: true,
        nothingReadable: false,
        digest,
        historyProgress: historyProgress(digest),
        isDemo: true,
        unreadableClients: [],
        retry: params.retry
    };
};
